export default {
  add: {
    method: 'POST',
    url: '/order/ID/document'
  },
  archive: {
    method: 'DELETE',
    url: '/order/ID/document/archive'
  },
  delete: {
    method: 'DELETE',
    url: '/order/ID/document'
  }
}
